import { Injectable, signal, Signal } from '@angular/core';
import { ITableColumn, TableConfig } from './table.model';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class GridService {
  constructor() { }
  tableConfig: Signal<TableConfig[]> = signal([]);

  pagination = new BehaviorSubject<any>({ pageNumber: 1, pageSize: 10 }); // Use system standard default
  // addRow = new BehaviorSubject<any>({ pageNumber: 1, pageSize: 5 });
  totalRecords = new BehaviorSubject<number>(0);

  saveRow = new BehaviorSubject<any>(null);
  deleteRow = new BehaviorSubject<any>(null);
  sortColumns = new BehaviorSubject<any>(null);
  // columns can be an array or a map keyed by footerServiceKey
  columns = new BehaviorSubject<ITableColumn[] | { [key: string]: ITableColumn[] }>(null);
  tableData = new BehaviorSubject<any>(null);
  appendTableData = new BehaviorSubject<any>(null);
  // holds the latest merged rows appended into the grid (per footer key handled in component)
  appendedRows = new BehaviorSubject<any[]>(null);
  TableRows = new BehaviorSubject<any>(null);
  filterColumn = new BehaviorSubject<any>(null);
  updateGridInfo = new BehaviorSubject<any>(null);
  getByHeaderId = new BehaviorSubject<any>(null);
  selectByHeaderId = new BehaviorSubject<any>(null);
  customSaveObservable = new BehaviorSubject<any>(null);
   isFooterUpdated = new BehaviorSubject<boolean>(false);
  setPagination(value: number) {
    this.pagination.next(value);
  }

  setTotalRecords(value: number) {
    this.totalRecords.next(value);
  }

  save(row: any) {
    this.saveRow.next(row);
  }

  delete(row) {
    this.deleteRow.next(row);
  }

  update(row: any) {
    this.updateGridInfo.next(row);
  } //send row data without click row save btn

  sort(sortField: string, sortOrder: number) {
    const sortOrderString = sortOrder === 1 ? 'ASC' : 'DESC';
    this.sortColumns.next({ sortField: sortField, sortOrder: sortOrderString });
  }
  //set filter
  filter(params) {
    this.filterColumn.next(params);
  }
  //clear filter


  // addNewRow(pageNumber: number, pageSize: number) {
  //   this.addRow.next({ pageNumber: pageNumber, pageSize: pageSize });
  // }

  setCoulmns(columns: ITableColumn[] | { [key: string]: ITableColumn[] }) {
    this.columns.next(columns);
  }

  setTableData(data: any) {
    this.tableData.next(data);
  }

  appendDataToTable(payload: { data: any[] | { [key: string]: any[] }, uniqueKeys?: string[], footerServiceKey?: string }) {
    this.appendTableData.next(payload);
  }

  setAppendedRows(rows: any[]): void {
    this.appendedRows.next(rows);
  }

  selectTableRows(data: any) {
    this.TableRows.next(data);
  }

  getTableDataByHeaderId(params) {
    this.getByHeaderId.next(params)
  }
selectTableDataByHeaderId(params) {
    this.selectByHeaderId.next(params)
  }

  customSave(data: any): void {
    this.customSaveObservable.next(data);
  }
  updateFooterFlag(flag: boolean): void {
    this.isFooterUpdated.next(flag);
  }
}
